import { FONT_SIZE_MEDIUM_IN_EM, V1_TO_V2_FONT_SIZE_RATIO } from '@i-ark/constants';
import { ItemTypeV1, HotspotTypeV1, InputTypes, HotspotIconPosition, HotspotIconPositionsV1 } from '@i-ark/models';
import { extractFileNameFromImageSrc } from './extractFileNameFromImageSrc.js';

function transformInputV1ToV2(input, pageIndex, index, backgroundSize) {
  const baseInput = {
    id: `${pageIndex.toString()}_item-${index.toString()}`,
    position: transformOriginToPosition(input.origin, backgroundSize),
    size: transformSize(input.size, backgroundSize),
    settings: {
      movable: input.move,
      cloneable: input.clone,
      hideDragHandle: true
    },
    style: transformStyle(input)
  };
  switch (input.type) {
    case ItemTypeV1.SINGLE_LINE:
    case ItemTypeV1.MULTI_LINE:
      if (input.readonly || baseInput.settings.movable || baseInput.settings.cloneable) {
        const textItem = {
          ...baseInput,
          style: {
            ...baseInput.style,
            verticallyCenterContent: input.type === ItemTypeV1.SINGLE_LINE,
            mockDefaultBrowserPadding: true
          },
          kind: "text",
          htmlContent: input.itemContent.replace(/\n/g, "<br />")
        };
        return textItem;
      } else {
        const inputItem = {
          ...baseInput,
          settings: {
            ...baseInput.settings,
            usePlaceholderAsDefaultValue: true
          },
          style: {
            ...baseInput.style,
            mockDefaultBrowserPadding: true
          },
          kind: "input",
          type: input.type === ItemTypeV1.SINGLE_LINE ? InputTypes.INPUT : InputTypes.TEXTAREA,
          placeholder: input.itemContent ?? "",
          maxLength: input.maxLength,
          characterCapacity: input.maxLength
        };
        return inputItem;
      }
    case ItemTypeV1.IMAGE: {
      const imageItem = {
        ...baseInput,
        alt: null,
        longDesc: null,
        naturalSize: input.size,
        kind: "image",
        src: input.backgroundImage,
        fileName: extractFileNameFromImageSrc(input.backgroundImage),
        updatedAt: Date.now(),
        settings: {
          ...baseInput.settings,
          showCrediting: false
        },
        angleInRadian: 0,
        crediting: {
          title: "",
          description: "",
          author: "",
          creditLine: "",
          year: ""
        }
      };
      return imageItem;
    }
    case ItemTypeV1.HOTSPOT: {
      const baseHotspotItem = {
        ...baseInput,
        style: {
          ...baseInput.style,
          icon: {
            enabled: input.hotspot.iconEnabled,
            position: transformHotspotIconPosition(input.hotspot.iconPosition)
          }
        }
      };
      if (input.hotspot.type === HotspotTypeV1.LINK) {
        const linkHotspotItem = {
          ...baseHotspotItem,
          kind: "linkHotspot",
          href: input.hotspot.value ?? ""
        };
        return linkHotspotItem;
      } else {
        const speechHotspotItem = {
          ...baseHotspotItem,
          kind: "speechHotspot",
          text: input.hotspot.value ?? ""
        };
        return speechHotspotItem;
      }
    }
  }
}
function transformOriginToPosition(origin, backgroundSize) {
  return {
    x: origin.x / backgroundSize.width,
    y: origin.y / backgroundSize.height
  };
}
function transformSize(size, backgroundSize) {
  return {
    width: size.width / backgroundSize.width,
    height: size.height / backgroundSize.height
  };
}
function transformStyle(input) {
  return {
    background: {
      color: input.backgroundColor,
      opacity: input.backgroundOpacity
    },
    border: {
      style: input.borderStyle,
      width: transformFontSize(Number(input.borderWidth)),
      color: input.borderColor,
      radius: transformFontSize(Number(input.borderRadius))
    },
    font: {
      family: input.fontFamily,
      size: Math.max(
        FONT_SIZE_MEDIUM_IN_EM,
        transformFontSize(Number(input.fontSize))
      ),
      color: input.fontColor
    }
  };
}
function transformFontSize(fontSize) {
  return fontSize * V1_TO_V2_FONT_SIZE_RATIO;
}
function transformHotspotIconPosition(position) {
  switch (position) {
    case HotspotIconPositionsV1.BOTTOM_LEFT:
      return HotspotIconPosition.BOTTOM_LEFT;
    case HotspotIconPositionsV1.BOTTOM_RIGHT:
      return HotspotIconPosition.BOTTOM_RIGHT;
    case HotspotIconPositionsV1.TOP_LEFT:
      return HotspotIconPosition.TOP_LEFT;
    case HotspotIconPositionsV1.TOP_RIGHT:
    default:
      return HotspotIconPosition.TOP_RIGHT;
  }
}

export { transformInputV1ToV2 };
//# sourceMappingURL=transformInputV1ToV2.js.map
